import { MenuItem, Select } from "@mui/material";
import * as React from "react";

export default function SelectMenuEmployee({ menu }) {
  const [selectedValue, setSelectedValue] = React.useState("None");

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <Select
      defaultValue={menu[0]}
      onChange={handleChange}
      value={selectedValue}
      sx={{
        bgcolor: "#fff",
        color: "#000",
        "& .MuiSelect-icon": {
          color: "#000", // Ensure the dropdown arrow is black
        },
      }}
    >
      {menu.map((item, index) => (
        <MenuItem
          key={index}
          value={item}
          sx={{
            bgcolor: "#000",
            color: "#fff",
            "&:hover": {
              bgcolor: "lightgray", // Optional: Highlight on hover
            },
          }}
        >
          {item}
        </MenuItem>
      ))}
    </Select>
  );
}
